import React, { useState } from 'react';
import { Box, Button, Form, FormField, Heading, TextInput } from 'grommet';
import axios from 'axios';
import {Link, useParams} from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';


function ForgotPassword() {
    const [password, setPassword] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { resetCode } = useParams();
    function handleSubmit(event) {
        event.preventDefault();

        axios.post(process.env.REACT_APP_BASE_API_URL + 'forgot_password/' + resetCode, {
            password,
        })
            .then(response => {
                setSuccessMessage(response.data.message);
                setErrorMessage('');
                toast.success('Password resettata!', {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                //window.location.href = '/webapp/';

            })
            .catch(error => {
                setSuccessMessage('');
                setErrorMessage(error.response.data.message);
            });
    }

    return (
        <Box align="center" pad="medium">
            <Heading level={1}>Reset password</Heading>
            {successMessage && <Box background="status-ok" pad="medium" margin={{ bottom: 'medium' }}>{successMessage}</Box>}
            {errorMessage && <Box background="status-error" pad="medium" margin={{ bottom: 'medium' }}>{errorMessage}</Box>}
            <Form onSubmit={handleSubmit}>
                <FormField name="password" label="New password">
                    <TextInput type="password" value={password} onChange={event => setPassword(event.target.value)} />
                </FormField>
                <Button type="submit" label="Invia" primary />
                <Link to="/">
                    <Button label="Torna al login" />
                </Link>
            </Form>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Box>

);
}

export default ForgotPassword;
